module.exports = __webpack_public_path__ + "static/media/envelope-exclamation.38c77062.svg";